// app/javascript/controllers/index.js
import { application } from "./application"

// Carga todos los *_controller.js de ./controllers y subcarpetas (modo eager)
const controllers = import.meta.glob("./**/*_controller.js", { eager: true })

for (const path in controllers) {
  const identifier = path
    .replace("./", "")
    .replace("_controller.js", "")
    .replace(/\//g, "--")
  application.register(identifier, controllers[path].default)
}
